import { tryOnBeforeMount } from '@vueuse/core';
import { useRoute, useRouter } from 'vue-router';
import { _passportDeferred } from './enable-token-base';

export function handlePaymentSuccess() {
    const route = useRoute();
    const router = useRouter();

    tryOnBeforeMount(async() => {
        await router.isReady();
        const { payment_state } = route.query;
        if (payment_state === 'success') {
            localStorage.removeItem('patsnap-authorizations');
            try {
                const _passport = await _passportDeferred.promise;
                if (!_passport) throw new Error('passport is not setup!');
                _passport.removeLocal();
            } catch (error) {
                console.error('[Use Plg Plan SDK]', 'passport is not setup!');
            }
            const query = { ...route.query };
            delete query.payment_state;
            await router.replace({ path: route.path, query, hash: route.hash });
            window.location.reload();
        }
    });
}
